import { render, staticRenderFns } from "./TenYear.vue?vue&type=template&id=4b94dd54&scoped=true"
import script from "./TenYear.vue?vue&type=script&lang=js"
export * from "./TenYear.vue?vue&type=script&lang=js"
import style0 from "./TenYear.vue?vue&type=style&index=0&id=4b94dd54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b94dd54",
  null
  
)

export default component.exports